import type { PermissionKey } from '@/lib/services/permissions.service';
import { z } from 'zod';

export const AI_SETTINGS_TABS = ['mine', 'company'] as const;
export const aiSettingsTabSchema = z.enum(AI_SETTINGS_TABS);
export type AiSettingsTab = z.infer<typeof aiSettingsTabSchema>;
export const DEFAULT_AI_SETTINGS_TAB: AiSettingsTab = 'mine';

export const PERSONAL_AI_SETTINGS_PERMISSION: PermissionKey = 'meetings.managePersonalAiSettings';
export const COMPANY_AI_PROMPT_PERMISSION: PermissionKey = 'meetings.manageCompanyAiSettings';

export const COMPANY_AI_SETTINGS_PERMISSIONS: readonly PermissionKey[] = [
	COMPANY_AI_PROMPT_PERMISSION,
	'companySettings.manageProfile',
];

export const AI_SETTINGS_PERMISSIONS: readonly PermissionKey[] = [
	PERSONAL_AI_SETTINGS_PERMISSION,
	...COMPANY_AI_SETTINGS_PERMISSIONS,
];
